import ViewerEvent from "./ViewerEvent";
import { debounce } from "throttle-debounce";
import {
  fetchUniversalURL,
  goToRecentPage,
  hasNextContentDoc,
  hasPreviousContentDoc,
} from "../features/nav/actions";
import { getPageError } from "../features/nav/load-status/selectors";
import { PageError } from "../features/nav/load-status/types";

/**
 * This is to wire up mosaic behaviors that should be intrinsically linked but
 * not necessary part of mosaic
 * @param viewer
 * @param store
 */
export function initLinkedBehaviors(viewer, store) {
  trackUniversalUrl(viewer, store);
  trackPrevAndNextPages(viewer, store);
  redirectInvalidPages(viewer, store);
}

function trackUniversalUrl(viewer, store) {
  const debouncedHandler = debounce(1000, () =>
    store.dispatch(fetchUniversalURL())
  );
  [ViewerEvent.PAGE_SCROLL, ViewerEvent.PAGE_READY].forEach((event) => {
    viewer.listen(event, debouncedHandler);
  });
}

function trackPrevAndNextPages(viewer, store) {
  viewer.listen(ViewerEvent.PAGE_READY, () => {
    store.dispatch(hasPreviousContentDoc());
    store.dispatch(hasNextContentDoc());
  });
}

function redirectInvalidPages(viewer, store) {
  viewer.listen(ViewerEvent.PAGE_ERROR, () => {
    // wait for redux update to process
    window.setTimeout(() => {
      if (getPageError(store.getState()) === PageError.PAGE_NOT_FOUND) {
        store.dispatch(goToRecentPage());
      }
    }, 0);
  });
}
